
import React, { useState, useRef, useEffect } from 'react';

import { ReactComponent as AccordionOpenedIcon } from '../../assets/icons/accordion-opened.svg';
import { ReactComponent as AccordionClosedIcon } from '../../assets/icons/accordion-closed.svg';

export default function AccordionItem({ title, children }) {
  
    const [isOpen, setIsOpen] = useState(false)
    const [maxH, setMaxH] = useState('0px')
    const contentRef = useRef(null)

    useEffect(() => {
        if (contentRef.current) {
        setMaxH(isOpen 
            ? `${contentRef.current.scrollHeight}px` 
            : '0px'
        )
        }
    }, [isOpen])

    return (
        <div className={`accordion${isOpen ? ' is-open' : ''}`}>
            <button
                type='button'
                onClick={() => setIsOpen(!isOpen)}
                className="accordion-btn"
            >
                <h3>{title}</h3>
                <div className="accordion-icon">
                    {isOpen ? <AccordionOpenedIcon/> : <AccordionClosedIcon />}
                </div>
            </button>
            <div 
                className="accordion-content"
                ref={contentRef}
                style={{ maxHeight: maxH }}
            >
                {children}
            </div>
        </div>
    )
}